import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {HANDSFREE_CAMERA} from "../../util/RouteConstants";
import HandsfreeCameraDeviceOverviewContextProvider from "./context/HandsfreeCameraDeviceOverviewContext";

class HandsfreeCameraDevicePage extends Component {
    render() {
        const getHandsfreeCameraRoutes = () => {
            return HANDSFREE_CAMERA;
        }

        return (
            <Column>
                <HandsfreeCameraDeviceOverviewContextProvider>
                    <TabLayout routes={getHandsfreeCameraRoutes()} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={getHandsfreeCameraRoutes()}/>
                </HandsfreeCameraDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default HandsfreeCameraDevicePage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/HandsfreeCameraDevicePage.js